import Controller from '../model/Controller';
import GigyaManager from "../business/GigyaManager";
import $ from "jquery";
import Utility from "../business/Utility";

class CalendarioHubCtrl extends Controller {
    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        // check if user is logged
        GigyaManager.getLoggedUser().then(() => {
            this.showLoggedArea();
        }, () => {
            $('.login-registration-button').attr('href', '/login?urlBack=' + Utility.getCurrentUri());
            $('.not-logged').addClass('check');
        });
    }

    showLoggedArea() {
        $('.calendario-2024 .logged').append('<a target="_blank" rel="noopener" href="/fe-web/pdf/landing-calendario/CalendarioMulinoBianco2024_mobile.pdf" class="button">Versione Mobile</a>');
        $('.calendario-2024 .logged').append('<a target="_blank" rel="noopener" href="/fe-web/pdf/landing-calendario/CalendarioMulinoBianco2024_desktop.pdf" class="button">Versione Desktop</a>');
        $('.calendario-2025 .logged').append('<a target="_blank" rel="noopener" href="/fe-web/pdf/landing-calendario/MULINO_BIANCO_CALENDARIO_MOBILE_2025.pdf" class="button">Scarica il calendario 2025</a>');
        $('.logged').addClass('check');
    }
}

export default CalendarioHubCtrl;
